<template>
  <u-dropdown ref="dropdown" v-model="display">
    <template slot="dropdown">
      <slot></slot>
    </template>
  </u-dropdown>
</template>
<script>
export default {
  data: function () {
    return {
      display: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dropdown-box/DropdownSelect.vue